import { createAction, props } from '@ngrx/store';
import { Candidate } from '../models/candidate.model';

export const setSelectedCandidates = createAction(
  '[Candidates Component] SetSelectedCandidates', props<{ selectedCandidates: Candidate[] }>()
);
